import(/* webpackMode: "eager", webpackExports: ["ClientInit"] */ "/app/packages/app/src/components/ClientInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/app/packages/app/src/components/Providers/AppProviders.tsx");
